export default "__VITE_ASSET__CzzwmbvN__"